import { rokidAgentStoreBaseUrl,rokidBaseUrl,rokidRcsUrl } from "@rokid/host";
import { request, type IRequest} from '@rokid/utils';
import type { IPostAgentPublishReq, IPostAgentPublishRes,IPostPromptTryReq,IPostPromptTryRes } from './publish.d';


/**
 * agent 提审
 */
export const agentPublish: IRequest<IPostAgentPublishReq, IPostAgentPublishRes> = (
  data
) => {
  return request({
    url: `${rokidAgentStoreBaseUrl}/developer/cozePublish`,
    method: 'post',
    data,
  }).then((res) => res);
};

/**
 * 提示词命中检测
*/
export const agentPromptTry = (data:IPostPromptTryReq) => {
  return request<IPostPromptTryReq, IPostPromptTryRes>({
    url: `${rokidBaseUrl}/api/prompt/try_match`,
    method: 'post',
    data,
  }).then((res) => res);
};



/*获取agent的分类列表*/
export const getAgentTypelist = () => {
  return request({
    url: `${rokidRcsUrl}/systemParam/getParam`,
    method: 'post',
    data: {"code":"cozeAgentTypeList"}
  }).then((res) => { 
    if (res.code === 1) {
      return JSON.parse(res.data.paramValue);
    } else { 
      return [];
    }
  });
};
